import { ROUTES } from '@/constants';
import { ax } from '@/utils';

const state = {
    products: [],
    models: [],
    count: 0,
    qte: 0,
    totalPages: 0,
    lists: [],
    tags: {
        style: [],
        category: [],
        tag: [],
        devices: [],
        materials: []
    },
    colors: []
};

const getters = {
    products: state => state.products,
    lists: state => state.lists,
    count: state => state.count,
    qte: state => state.qte,
    totalPages: state => state.totalPages,
    tags: state => state.tags,
    colors: state => state.colors,
};

/**********				actions				**********/
const actions = {
    getPage({ commit }, {adminList, qte, page}) {
        return ax
            .post(ROUTES.GET_PAGE(), {adminList, qte, page})
            .then(res => {
                commit('STORE_ADMIN_PRODUCTS', res.data);
                return res;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getAllLists({ commit }){
        return ax
            .post(ROUTES.GET_LISTS(), {})
            .then(res => {
                commit('STORE_LISTS', res.data.lists);
                return res;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getProduct(_, id) {
        return ax
            .post(ROUTES.GET_PRODUCT(), {id})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    updateProduct(_, product) {
        if (product.brand) {
            product.brand = product.brand._id;
        }
        return ax
            .post(ROUTES.UPDATE_PRODUCT(), {product})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    createProduct(_, product) {
        return ax
            .post(ROUTES.CREATE_PRODUCT(), {product})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getProductVariants(_, id) {
        return ax
            .post(ROUTES.GET_PRODUCT_VARIANTS(), {productId: id})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getAllProducts(_, page) {
        return ax
            .get(ROUTES.GET_PRODUCTS() + ("?page="+page || ""))
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getColors({ commit }) {
        return ax
            .get(ROUTES.GET_COLORS())
            .then(res => {
                commit('STORE_COLORS', res.data.colors);
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getColorProducts(_, id){
        return ax
            .post(ROUTES.GET_COLOR_PRODUCTS(), {id})
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    updateColor(_, color) {
        return ax
            .post(ROUTES.UPDATE_COLOR(), {color})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    mergeColors({ commit }, {from, to}) {
        return ax
            .post(ROUTES.MERGE_COLOR(), {from, to})
            .then(() => {
                commit('REMOVE_DELETED_COLOR', from)
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    mergeTags({ commit }, {from, to, type}) {
        return ax
            .post(ROUTES.MERGE_TAGS(), {from, to})
            .then(() => {
                commit('REMOVE_DELETED_TAG', {id: from, type})
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    deleteColor({commit}, id){
        return ax
            .post(ROUTES.DELETE_COLOR(), {id})
            .then(() => {
                commit('REMOVE_DELETED_COLOR', id)
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getVariant(_, id) {
        return ax
            .get(ROUTES.GET_VARIANT(id))
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    deleteVariant({commit}, id){
        return ax
            .post(ROUTES.DELETE_VARIANT(), {id})
            .then(() => {
                commit('REMOVE_DELETED_VARIANT', id)
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    duplicateVariant(_, id){
        return ax
            .post(ROUTES.DUPLICATE_VARIANT(), {id})
            .then((data) => {
                return data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getTags({ commit }, type) {
        return ax
            .post(ROUTES.GET_TAGS(), {type})
            .then(res => {
                commit('STORE_TAGS', {tags: res.data.tags, type});
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    removeTag({ commit }, tag) {
        return ax
            .post(ROUTES.REMOVE_TAG(), {tag})
            .then(res => {
                commit('REMOVE_TAG', tag);
                return res;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getTagParents(_, id) {
        return ax
            .get(ROUTES.GET_TAG_PARENTS(id))
            .then(res => {
                return res.data;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    getTagProducts(_, id) {
        return ax
            .get(ROUTES.GET_TAG_PRODUCTS(id))
            .then(res => {
                return res.data.products;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    createTag({ commit }, tag) {
        return ax
            .post(ROUTES.CREATE_TAG(), {tag})
            .then(res => {
                commit('ADD_TAG', res.data.tag);
                return res.data.tag;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    createColor({ commit }, color) {
        return ax
            .post(ROUTES.CREATE_COLOR(), {color})
            .then(res => {
                commit('ADD_COLOR', res.data.color);
                return res.data.color;
            })
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    updateTag(_, tag) {
        return ax
            .post(ROUTES.UPDATE_TAG(), {tag})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    createVariant(_, variant) {
        return ax
            .post(ROUTES.CREATE_VARIANT(), {variant})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    updateVariant(_, variant) {
        return ax
            .post(ROUTES.UPDATE_VARIANT(), {variant})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    uploadImage(_, image) {
        return ax
            .post(ROUTES.UPLOAD_IMAGE(), {image})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },

    uploadImageFromInternet(_, url) {
        return ax
            .post(ROUTES.UPLOAD_IMAGE_FROM_INTERNET(), {url})
            .catch(error => {
                return Promise.reject(error.config);
            });
    },
};

/**********				mutations				**********/

const mutations = {
    STORE_ADMIN_PRODUCTS(state, data) {
        state.products = data.products;
        state.count = data.count;
        state.qte = data.qte;
        state.totalPages = Math.ceil(data.count / data.searchQte);
    },
    STORE_PRODUCTS(state, products) {
        state.products = products;
    },
    REMOVE_DELETED_VARIANT(state, id) {
        state.products = state.products.filter(e => e._id !== id);
    },
    REMOVE_TAG(state, {id}) {
        state.tags = state.tags.filter(e => e._id !== id);
    },
    STORE_LISTS(state, lists) {
        state.lists = lists
    },
    ADD_TAG(state, tag) {
        state.tags[tag.type].push(tag);
        state.tags[tag.type].sort(function(a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    },
    ADD_COLOR(state, color) {
        state.colors.push(color);
    },
    STORE_TAGS(state, {tags, type}) {
        state.tags[type] = tags;
        state.tags[type].sort(function(a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    },
    STORE_COLORS(state, colors) {
        state.colors = colors;
        state.colors.sort(function(a, b) {
            var textA = a.colorName.toUpperCase();
            var textB = b.colorName.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    },
    REMOVE_DELETED_COLOR(state, id) {
        state.colors = state.colors.filter(e => e._id !== id);
    },
    REMOVE_DELETED_TAG(state, {id, type}) {
        state.tags[type] = state.tags[type].filter(e => e._id !== id);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
